import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const Header = styled.div`
  display: flex;
  min-width: 832px;
  padding: 12px 24px;
  align-items: center;
  align-self: stretch;
  border-radius: 12px;
  background: var(--component-color-fill-alternative);
  gap: 20px;
`;

export const DeviceIdLabel = styled.div`
  display: flex;
  min-width: 240px;
  max-width: 400px;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
`;

export const DevicePositionLabel = DeviceIdLabel;

export const BatteryInfoLabel = styled.div`
  display: flex;
  min-width: 200px;
  max-width: 320px;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
`;

export const TableContainer = styled.div<{ isShow: boolean }>`
  display: flex;
  opacity: ${({ isShow }) => (isShow ? 1 : 0)};
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  max-height: ${(props) => (props.isShow ? "auto" : "0")};
`;
